module.exports = __webpack_public_path__ + "static/media/mobile-onboarding-screen.bbaf76cc.png";